import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { NotFound } from 'src/components/NotFound'

import { AuthLayout } from './layout'
import { Login, Logout, ForgotPassword, ResetPassword } from './pages'

export const AuthRouter = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/login`} exact>
        <AuthLayout>
          <Login />
        </AuthLayout>
      </Route>
      <Route path={`${path}/logout`} exact>
        <Logout />
      </Route>
      <Route path={`${path}/forgot-password`} exact>
        <AuthLayout>
          <ForgotPassword />
        </AuthLayout>
      </Route>
      <Route path={`${path}/reset-password`} exact>
        <AuthLayout>
          <ResetPassword />
        </AuthLayout>
      </Route>
      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  )
}
